<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between">
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo" [src]="'logos/nav-logo.png' | contentAssetImage" draggable="false" />
    </a>
    <div class="d-flex justify-content-center align-items-center">
      <a class="nav-item me-2">
        <fgb-notification-button></fgb-notification-button>
      </a>

      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown">
    <div class="d-flex flex-column mobile-nav-menu-content my-2">
      <!-- Close Button -->
      <button
        class="close-button position-absolute border-0"
        attr.aria-label="{{ 'modal.close' | translate }}"
        (click)="isCollapsed = !isCollapsed"
      >
        <i class="material-icons close-btn text-white">close</i>
      </button>
      <div>
        <img alt="" class="logo px-2" [src]="'logos/nav-logo.png' | contentAssetImage" draggable="false" />
      </div>
      <ng-container
        *ngIf="{ memberDetails: memberDetails$ | async, ecash: ecash$ | async, memberCard: memberCard$ | async } as info"
      >
        <div class="container info mt-3 text-white">
          <h3 class="font-size-20">{{ info.memberDetails.FirstName }} {{ info.memberDetails.Surname }}</h3>
          <div class="font-size-12">{{ info.memberDetails.ExternalRefNumber }} - {{ 'member.card.id' | translate }}</div>
        </div>
      </ng-container>
      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container mt-4">
        <a class="nav-item" [routerLink]="['/']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
          <div class="nav-text fw-bold">{{ 'nav.home' | translate }}</div>
          <span class="material-icons-outlined"> keyboard_arrow_right </span>
        </a>

        <!--Kids Nav-->
        <ng-container *inPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/activity']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.activity' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/rewards/marketplace']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/games']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.earn' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/gallery']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/worksheets']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.worksheets' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/terms']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.terms' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>
        </ng-container>

        <!--Member Nav-->
        <ng-container *notInPopulation="[population.Kids]">
          <a
            class="nav-item"
            [routerLink]="['/hawksbucks']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.hawksbucks' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.wallet' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.account' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" href="{{ 'nav.membership.url' | translate }}">
            <div class="nav-text fw-bold">{{ 'nav.membership' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/guardians']" [routerLinkActive]="'active'">
            <div class="nav-text fw-bold">{{ 'nav.kids' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a
            class="nav-item"
            [routerLink]="['/payment']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-text fw-bold">{{ 'nav.payment' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/faq']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/earn']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.earn' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" [routerLink]="['/my-renewals']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
            <div class="nav-text fw-bold">{{ 'nav.renewals' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" href="{{ 'nav.shop.url' | translate }}">
            <div class="nav-text fw-bold">{{ 'nav.shop' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item" href="{{ 'nav.contact.url' | translate }}">
            <div class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</div>
            <span class="material-icons-outlined"> keyboard_arrow_right </span>
          </a>

          <a class="nav-item logout-link-div" (click)="logout()">
            <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
          </a>
        </ng-container>

        <ng-container *inPopulation="[population.Kids]">
          <div class="container">
            <div class="w-100">
              <fgb-back-to-guardian></fgb-back-to-guardian>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #accordionNav let-children="children" let-icon="icon" let-navTitle="navTitle">
  <div ngbAccordion class="nav-item-title-div w-100">
    <div ngbAccordionItem [collapsed]="true" class="w-100">
      <h2 ngbAccordionHeader class="mt-0">
        <button ngbAccordionButton data-testid="accordion-button" class="w-100 nav-title">
          <span class="icon material-icons me-2" aria-hidden="true">{{ icon }}</span>
          <span class="text-uppercase"> {{ navTitle | translate }}</span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ng-container *ngFor="let child of children">
              <ng-container *ngIf="child?.externalLink">
                <a class="nav-child" [innerHTML]="child.link | translate | markdownTranslate"> </a>
              </ng-container>
              <ng-container *ngIf="!child?.externalLink">
                <a
                  class="nav-child"
                  [routerLinkActive]="'active'"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="child.link"
                  >{{ child.title | translate }}</a
                >
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-template>
